import PropTypes from "prop-types"
import React from "react"

import InstantGift from "areas/instant-gift/item"
import {
  instantGiftDemoData,
  instantGiftVideoData as getInstantGiftVideoData,
} from "helpers/holiday"

const Demo = ({ inModal }) => {
  const instantGiftVideoData = getInstantGiftVideoData()
  return (
    <InstantGift
      giftData={{
        available_views: ["t2", "t", "m"],
        box_print_src_image_url: null,
        details: [
          "Metal: Sterling Silver",
          "Stone 1: Pink Tourmaline / October",
          "Stone 2: Blue Topaz / December",
          "Accent Stones: Cubic Zirconia",
          "Engraving Font: Cursive",
          "Base Engraving: Love Always",
          "Engraving 1: Ashley",
          "Engraving 2: Daniel",
          "Size:  7.00",
        ],
        estimated_delivery_date: instantGiftVideoData.delivery_date,
        gift_message: instantGiftVideoData.giftMsg,
        image_url:
          "https://imgsmblystaging.jewlr.com/jwl0018.jpg?view=t2&dim=512&sku=w&ef=Cursive&e0=Love%20Always&e1=Ashley&e2=Daniel&s1=10PTOU&s2=12BTPZ",
        prefs: {
          as: "04CZIR",
          e0: "Love Always",
          e1: "Ashley",
          e2: "Daniel",
          ef: "Cursive",
          s1: "10PTOU",
          s2: "12BTPZ",
          sku: "SS",
          sz: "7.00",
        },
        recipient_name: instantGiftVideoData.recipient_name,
        sender_name: instantGiftVideoData.sender_name,
        shipping_link: "",
        state: "in_production",
        status: {
          customer_state: "customer_new",
          description: false,
          title: "Order Placed",
        },
        style_code: "JWL0018",
        title: "Double Heart Gemstone Ring with Accents",
        video: {
          url: `https://assets.jewlr.com/instant-gift/videos/${instantGiftVideoData.video}.mp4`,
        },
        ...instantGiftDemoData,
      }}
      inModal={inModal}
      isDemo
    />
  )
}

Demo.propTypes = {
  inModal: PropTypes.bool,
}

export default Demo
